import { codeFlagValueFromRow } from './codeFlags';

export const CODE_FLAG_ACTIONS = { SET: 'set', DELETE: 'delete' };

export const BRANCH_OPTIONS = [
  { value: 'dev6', label: 'dev6 (QA)' },
  { value: 'master', label: 'master (Production)' },
];

export const ACTION_OPTIONS = [
  { value: CODE_FLAG_ACTIONS.SET, label: 'Set (create or update)' },
  { value: CODE_FLAG_ACTIONS.DELETE, label: 'Delete' },
];

export const TYPE_OPTIONS = [
  { value: 'boolean', label: 'Boolean' },
  { value: 'string', label: 'String' },
];

export const BULK_FORM_INITIAL_STATE = {
  branch: 'dev6',
  action: CODE_FLAG_ACTIONS.SET,
  key: '',
  type: 'boolean',
  boolValue: false,
  stringValue: '',
  targetAll: true,
  identifiers: [],
  force: false,
};

export const formatFlagValue = (value) => {
  if (value === undefined || value === null) return 'not set';
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  return `"${value}"`;
};

export const currentFlagValue = (tenant, key) => {
  const flags = tenant?.codeFlags || {};
  const trimmedKey = (key || '').trim();
  return Object.prototype.hasOwnProperty.call(flags, trimmedKey) ? flags[trimmedKey] : undefined;
};

export const tenantsInBranch = (tenants = [], branch) =>
  (tenants || []).filter((tenant) => tenant.branch === branch).sort((a, b) => a.name.localeCompare(b.name));

export const collectFlagKeys = (tenants = []) =>
  Array.from(new Set((tenants || []).flatMap((tenant) => Object.keys(tenant.codeFlags || {})))).sort();

const normalizeIdentifiers = (identifiers) => {
  if (Array.isArray(identifiers)) return identifiers;
  if (typeof identifiers === 'string' && identifiers) return [identifiers];
  return [];
};

export const buildBulkRequest = (
  { branch, action, key, type, boolValue, stringValue, targetAll, identifiers, force },
  dryRun = false
) => {
  const request = {
    branch,
    action,
    key: (key || '').trim(),
    target: targetAll ? { all: true } : { identifiers: normalizeIdentifiers(identifiers) },
    dryRun,
    force: Boolean(force),
  };

  if (action === CODE_FLAG_ACTIONS.SET) {
    request.value = codeFlagValueFromRow({ type, boolValue, stringValue });
  }

  return request;
};

export const isDestructiveRequest = (request) =>
  request.action === CODE_FLAG_ACTIONS.DELETE || request.target?.all === true;

export const describeRequest = (request, tenantCount) => {
  const scope = request.target?.all ? `all ${tenantCount} tenants` : `${tenantCount} selected tenant(s)`;
  const change =
    request.action === CODE_FLAG_ACTIONS.DELETE
      ? `delete "${request.key}"`
      : `set "${request.key}" to ${formatFlagValue(request.value)}`;

  const forceNote = request.force ? ' Tenants that already match will be republished as well.' : '';

  return `This will ${change} on ${scope} in ${request.branch}.${forceNote}`;
};

export const apiErrorMessage = (err) => {
  const data = err?.response?.data;
  if (data?.validationErrors?.length) {
    return data.validationErrors.map(({ field, error }) => `${field}: ${error}`).join('; ');
  }
  const status = err?.response?.status;
  if (!err?.response || status === 502 || status === 504) {
    return `${
      err?.message || 'The request did not complete'
    }. Some tenants may already be updated. Run a preview to see the current state.`;
  }
  return data?.message || err?.message || 'Unknown error';
};
